import { types, async } from '~/utils/typeCreator'

export default types([...async('LOAD_USER'), 'CLEAR_STATE'], 'PROFILE')
